import { dashboardInfoQueryOptions } from '@/src/queries/activity-queries'
import { getCurrentYearWeek } from '@/src/utils/year-week'
import { useSuspenseQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { StatisticsMetricCard } from '../StatisticsMetricCard'
import { STATISTICS_CARD_PLACEHOLDER_VALUE } from './statistics-card.constants'

const MINUTES_PER_HOUR = 60

export function ExerciseTimeMetricCard() {
  const { t } = useTranslation(['statistics', 'common'])
  const yearWeek = getCurrentYearWeek()
  const dashboardInfoQuery = useSuspenseQuery(
    dashboardInfoQueryOptions(yearWeek),
  )
  const timePast30Days = dashboardInfoQuery.data.totalTime
  let value = STATISTICS_CARD_PLACEHOLDER_VALUE

  if (timePast30Days != null) {
    if (timePast30Days < MINUTES_PER_HOUR) {
      value = t('statistics:metric_time_value_minutes', {
        count: timePast30Days,
      })
    } else {
      const hours = Math.floor(timePast30Days / MINUTES_PER_HOUR)
      const minutes = timePast30Days % MINUTES_PER_HOUR

      value =
        minutes === 0
          ? t('statistics:metric_time_value_hours', {
              count: hours,
            })
          : `${t('statistics:metric_time_value_hours', {
              count: hours,
            })} ${t('statistics:metric_time_value_minutes', {
              count: minutes,
            })}`
    }
  }

  return (
    <StatisticsMetricCard
      id="time"
      title={t('statistics:metric_time_title')}
      value={value}
      timeframe={t('statistics:timeframe_past_30_days')}
      iconName="time"
    />
  )
}
